export * from './template-outlet.module';
